// extracted by mini-css-extract-plugin
export default {"wrapper":"htFkB","content":"QXWP6","header":"iD9so","button":"dHchM","buttons":"RDKyx"};